import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';

export default withStyles(() => ({
  root: {
    minWidth: 750,
    height: '100%',
  },
}))(Table);
